var _line, _line2, _line3, _line4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiningIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.75737,
    y1: 13.5757,
    x2: 23.2725,
    y2: 13.5757,
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4237,
    y1: 9.09126,
    x2: 15.3025,
    y2: 13.9397,
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.515,
    y1: 24.2424,
    x2: 15.515,
    y2: 14.5455,
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.1998,
    y1: 9.30911,
    x2: 16.2907,
    y2: 13.1879,
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9162 23.897L23.3436 14.8418C23.8689 14.1018 23.8108 13.0964 23.2037 12.4219L20.4564 9.36935C20.0886 8.96069 19.5646 8.72734 19.0148 8.72734H11.5471C10.9528 8.72734 10.3912 8.99989 10.0235 9.46685L7.66316 12.4641C7.14155 13.1265 7.10762 14.0499 7.57922 14.7488L13.7271 23.8593C14.4851 24.9825 16.1319 25.002 16.9162 23.897Z",
    stroke: "#0BC196",
    strokeWidth: 1.93939
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiningIncome);
export default __webpack_public_path__ + "static/media/miningIncome.1e974b78ed510eb36d8273f559b4b278.svg";
export { ForwardRef as ReactComponent };